import React, { Component } from 'react';
import Author from './Author';
import iconIn from './../assets/iconIn.png';

class ContactButton extends Component {

    render() {
         return (
            <div className="contactButton">
                <a href="mailto:nicolas@willcer.com" target="_blank" rel="noopener noreferrer"><Author /></a>
                <a href="https://www.linkedin.com/in/nicolashuart/" target="_blank" rel="noopener noreferrer"><img src={iconIn} alt="Linkedin"/></a>
            </div>
        );
    }
}

export default ContactButton;